import React, { useEffect } from "react";
import "./VoteModal.css";

function StatusModal({ isOpen, onClose, type = "success", title, message }) {
  // Bloquear scroll quando modal abrir
  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const icons = {
    success: { emoji: "✅", title: title || "Sucesso!" },
    error: { emoji: "❌", title: title || "Erro!" },
    warning: { emoji: "⚠️", title: title || "Atenção!" },
    info: { emoji: "ℹ️", title: title || "Informação" },
  };

  const config = icons[type] || icons.info;

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content" style={{ maxWidth: "500px" }}>
        <div className="modal-header">
          <h2 className="modal-title">
            <span>{config.emoji}</span> {config.title}
          </h2>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modal-body" style={{ textAlign: "center", padding: "2rem" }}>
          <div className="status-icon" style={{ fontSize: "4rem", marginBottom: "1.5rem", display: "block" }}>
            {config.emoji}
          </div>
          <p style={{ fontSize: "1.2rem", color: "var(--text-primary)", lineHeight: "1.5" }}>{message}</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary btn-block" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

export default StatusModal;
